<button matIconButton [matMenuTriggerFor]="menu">
  <svg lucideRefreshCcw [size]="8" matTooltip="Renouvellement"></svg>
</button>
<mat-menu #menu="matMenu">
  @for (contract of contracts; track $index) {
    <button mat-menu-item (click)="contractClicked.emit(contract.id)">
      <span>{{ contract.startDate | date }} - {{ contract.contractType }}</span>
    </button>
  }
</mat-menu>
